module.exports = __webpack_public_path__ + "img/polygon.6f080bac.svg";